<ng-container *transloco="let t; prefix: 'addNewProjectDialog'">
  <div class="t-pt-4 t-w-96">
    <div class="t-flex t-items-center t-justify-between">
      <div
        class="t-text-slate-700 t-flex t-items-center t-gap-2 t-font-semibold t-text-base"
      >
        <i [class]="isEdit() ? 'pi pi-file-edit' : 'pi pi-plus'"></i>
        <span>{{ t(isEdit() ? "editTitle" : "title") }}</span>
      </div>
      <p-button
        variant="text"
        size="small"
        severity="secondary"
        (onClick)="ref.close()"
        ><i class="pi pi-times t-text-slate-700 t-font-semibold"></i
      ></p-button>
    </div>

    <form [formGroup]="form" (submit)="onSaveClick()" class="t-pt-4">
      <div class="t-flex t-flex-col t-gap-2.5">
        <div class="t-flex t-flex-col t-gap-1">
          <label for="titleField">{{ t("projectTitle") }}</label>
          <input
            pInputText
            id="titleField"
            formControlName="title"
            [placeholder]="t('projectTitlePlaceholder')"
          />
        </div>

        <div class="t-flex t-flex-col t-gap-1">
          <label for="address">{{ t("address") }}</label>
          <p-autocomplete
            id="address"
            [suggestions]="filteredAddresses()"
            (completeMethod)="filterAddresses($event)"
            [minLength]="3"
            [placeholder]="t('addressPlaceholder')"
            [dropdown]="false"
            (onSelect)="onAddressSelect($event.value)"
            (onClear)="onAddressClear()"
            [fluid]="true"
            [showClear]="true"
            appendTo="body"
            optionLabel="formatted"
          ></p-autocomplete>

          @if (error) {
            <div
              class="t-mt-3 t-p-3 t-bg-red-50 t-border t-border-red-200 t-rounded t-text-red-700"
            >
              {{ error }}
            </div>
          }
        </div>

        <div class="t-flex t-flex-col t-gap-1">
          <label for="projectManager">{{ t("projectManager") }}</label>
          <p-select
            id="projectManager"
            formControlName="projectManager"
            [placeholder]="t('projectManagerPlaceholder')"
            [options]="projectManagers()"
            [filter]="true"
            optionLabel="name"
            appendTo="body"
            class="t-text-base"
          >
          </p-select>
        </div>

        <div class="t-flex t-flex-col t-gap-1">
          <label for="titleField">{{ t("takeOff") }}</label>
          <p-iconfield>
            <p-inputicon class="pi pi-link" />
            <input
              pInputText
              id="quantities"
              formControlName="quantitiesTakeOffSheetUrl"
              [fluid]="true"
              [placeholder]="t('takeOffPlaceholder')"
            />
          </p-iconfield>
          @let takeOffControl = form.get("quantitiesTakeOffSheetUrl");
          @if (takeOffControl?.invalid && takeOffControl?.touched) {
            <small class="t-text-red-500">{{
              t("takeOffValidUrlError")
            }}</small>
          }
        </div>

        <div class="t-flex t-flex-col t-gap-4 t-pt-4">
          <div class="t-flex t-gap-2">
            <p-button
              [label]="t('cancel')"
              severity="secondary"
              [fluid]="true"
              class="t-flex-1"
              (onClick)="ref.close()"
            ></p-button>
            <p-button
              [disabled]="form.invalid"
              [label]="t('save')"
              [fluid]="true"
              class="t-flex-1"
              type="submit"
            ></p-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>
